// File containing utility functions for calculating pixel metrics.
const DEFAULT_EREV_9 = 85;
const DEFAULT_ELTV_13 = 60;

export function getHealthyMindRevenueMetrics(isSoldOut, order) {
  const erev9 = !isSoldOut ? order.erev_9_months : DEFAULT_EREV_9;
  const eltv13 = !isSoldOut ? order.eltv_13_months : DEFAULT_ELTV_13;
  return { eltv13, erev9 };
}
